<template>
	<div class="idi-table patients">
		<div class="idi-header">
			<div class="idi-cell"></div>
			<div class="idi-cell">{{ $t('labels.general.name') }}</div>
			<div class="idi-cell">{{ $t('labels.general.uptime') }}</div>
			<div class="idi-cell">{{ $t('labels.general.last_sync') }}</div>
			<div class="idi-cell">{{ $t('labels.general.position') }}</div>
			<div class="idi-cell"></div>
		</div>
		<div v-for="group in groups.data" :key="group.id" v-check-group="{ user_uid, group_id: group.id }">
			<div class="group">
				<div>{{ group.name }}</div>
				<div>
					<button v-check-user:patients_edit_group="user_uid" class="btn btn-small btn-round" @click="editGroup(group.id)">{{ $t('buttons.general.edit') }}</button>
					<button v-check-user:patients_delete_group="user_uid" class="btn btn-small btn-round" @click="deleteGroup(group.id)">{{ $t('buttons.general.delete') }}</button>
				</div>
			</div>
			<router-link
				v-for="patient in group.elements"
				:key="patient.id"
				:to="{ name: 'WatchDashboard', params: { user_uid, watch_id: patient.id } }"
				class="idi-row"
				:class="{ active: patient.online }">
				<div class="idi-cell grid-area-picture">
					<div class="bullet"></div>
					<avatar-picture-virtual-watch v-if="patient.picture" :watch_id="patient.id"/>
					<svgicon v-else name="watch" :fill="false" class="avatar-picture-virtual-watch-none"/>
				</div>
				<div class="idi-cell grid-area-name">
					<span>{{ patient.profile_name }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ timepass(patient.uptime, true) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ timepass(patient.last_sync) }}</span>
				</div>
				<div class="idi-cell">
					<span>{{ patient.last_position }}</span>
				</div>
				<div class="idi-cell grid-area-operations align-right">
					<button class="btn btn-round btn-small">{{ $t('buttons.actions.view_watch') }}</button>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	props: [
		'user_uid',
		'groups'
	],
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		}
	},
	methods: {
		editGroup (group_id) {
			this.$root.$emit('editGroup', group_id)
		},
		deleteGroup (group_id) {
			this.$emit('deleteGroup', group_id)
		},
		timepass(date, flag = false) {
			if (date == null)
				return '--'
			return moment().to(date, flag)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesPatientsList.vue